export default __webpack_public_path__ + "media/images/argyros-center-stacked-e1542ff477a061f84436837782bb108a.svg";